import { observer } from 'mobx-react';

import OptionItem from '../../../../../configurator/components/ConfigurationSummary/OptionItem/OptionItem';
import Accordion from '../../../../../shared/components/Accordion/Accordion';
import CustomScrollbar from '../../../../../shared/components/CustomScrollbar/CustomScrollbar';
import Icon from '../../../../../shared/components/Icon/Icon';
import List from '../../../../../shared/components/List/List';
import Price from '../../../../../shared/components/Price';
import Heading, { HeadingSize } from '../../../../../shared/components/Typography/Heading/Heading';
import { Region } from '../../../../../shared/regions/Region';
import ModularConfiguratorCoordinatorState from '../../ModularConfiguratorCoordinatorState';
import ModularConfigurationShare from './ModularConfigurationShare/ModularConfigurationShare';
import css from './ModularConfiguratorSummary.css';

interface ModularConfiguratorSummaryProps {
  state: ModularConfiguratorCoordinatorState;
}

const ModularConfiguratorSummary = observer(({ state }: ModularConfiguratorSummaryProps) => {
  return (
    <section className={css.container}>
      <button type="button" className={css.buttonClose} onClick={state.goBackToConfigurator}>
        <Icon className={css.icon} name="arrowNext" />
        <span className="visuallyHidden">Back to configurator</span>
      </button>
      <CustomScrollbar viewClassName={css.inner}>
        <Heading level={2} size={HeadingSize.Small}>
          Order summary
        </Heading>
        <div className={css.summary}>
          <div className={css.productName}>{state.productFamilyName}</div>
          {state.usedComponentConfigurations.map((c) => (
            <Accordion
              className={css.component}
              titleClassName={css.title}
              titleExpandedClassName={css.expanded}
              contentClassName={css.details}
              title={`${c.name} (${c.counter})`}
              key={c.code}
            >
              <List
                items={[...c.features.options, ...c.features.accessories]}
                itemClassName={css.feature}
                itemRenderer={(item) => (
                  <OptionItem nameClassName={css.name} selectedFeature={item} key={item.feature.id} />
                )}
              />
            </Accordion>
          ))}
          {state.configurator?.canBePurchased && (
            <div className={css.price}>
              Total price: <Price className={css.amount} price={state.configurator.totalPrice} />
            </div>
          )}
          <Region
            name="ModularConfiguratorSummary"
            data={{
              state: state,
              configuratorSummaryState: state.configurator.summary,
              translation: state.translation.configurationPage.summary,
              requestQuoteLinkTranslation: state.translation.requestQuoteLink,
            }}
          />
        </div>

        <ModularConfigurationShare
          className={css.share}
          state={state.configurator.summary}
          isLoadingConfigurationCode={state.configurator.isLoadingConfigurationCode}
          isLoadingConfigurationCodeError={state.configurator.isLoadingConfigurationCodeError}
          translation={state.translation.configurationPage.summary.shareSection}
        />
      </CustomScrollbar>
    </section>
  );
});

export default ModularConfiguratorSummary;
